import Vue from 'vue'
import Vuex from "vuex"
import App from './App.vue'

import Ionic from '@ionic/vue'
import '@ionic/core/css/core.css'
import '@ionic/core/css/ionic.bundle.css'
import Select2 from 'v-select2-component';
import { IonicVueRouter } from "@ionic/vue"

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

Vue.use(CoolLightBox)

Vue.use(IonicVueRouter)
Vue.component('Select2', Select2);
Vue.component('loader', require('./components/partials/Loader.vue').default);
Vue.component('headerlogo', require('./components/partials/HeaderLogo.vue').default);
Vue.component('bg', require('./components/partials/Bg.vue').default);

Vue.config.productionTip = false;
Vue.use(Ionic);
Vue.use(Vuex);

Vue.mixin({
  data: function () {
    return {
      get fileUrl() {
        return "https://floatingdata.sviluppo-siti.it/uploads/reserved";
      },
      get apiUrl() {
        return "https://floatingdata.sviluppo-siti.it";
      },
    }
  }
})

const store = new Vuex.Store({
  state: {
    api_token: '',
    user_id: '',
    user_name: '',
    user_role: '',
    user_yachts: [],
  },
  mutations: {
    initialiseStore(state) {
      // Check if the ID exists
      if (localStorage.getItem('store')) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem('store')))
        );
      }
    },
    setApiToken(state, val) {
      state.api_token = val;
    },
    setUserId(state, val) {
      state.user_id = val;
    },
    setUserName(state, val) {
      state.user_name = val;
    },
    setUserRole(state, val) {
      state.user_role = val;
    },
    setUserYachts(state, val) {
      state.user_yachts = val;
    },
  }
});
store.subscribe((mutation, state) => {
  localStorage.setItem('store', JSON.stringify(state));
});

let firstView = '/login';
let dataStorage = localStorage.getItem('store');
if (dataStorage) {
  dataStorage = JSON.parse(dataStorage);
  if (dataStorage.api_token) {
    firstView = '/home';
  }
}

const router = new IonicVueRouter({
  routes: [
    {
      path: "/",
      redirect: firstView
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/components/Login"),
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/components/Home"),
    },
    {
      path: "/files",
      name: "files",
      component: () => import("@/components/Files"),
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/components/Profile"),
    },
    {
      path: "/templates",
      name: "templates",
      component: () => import("@/components/Templates"),
    },
    {
      path: "/templates/edit/:name",
      name: "templates-edit",
      component: () => import("@/components/TemplatesEdit"),
    },
    {
      path: "/new-yacht",
      name: "new-yacht",
      component: () => import("@/components/NewYacht"),
    },
    {
      path: "/new-yacht/specifications/:id",
      name: "new-yacht-specifications",
      component: () => import("@/components/NewYachtSpecifications"),
    },
    // {
    //   path: "/new-yacht/index/:id",
    //   name: "new-yacht-index",
    //   component: () => import("@/components/NewYachtIndex"),
    // },
    {
      path: "/report/:id",
      name: "report",
      component: () => import("@/components/ReportList"),
    },
    {
      path: "/report/edit/:id",
      name: "report-edit",
      component: () => import("@/components/NewYachtIndex"),
    },
    {
      path: "/report/details/:id",
      name: "report-details",
      component: () => import("@/components/Report"),
    },
    {
      path: "/report/compile/text/:id",
      name: "compile-text",
      component: () => import("@/components/CompileIndexText"),
    },
    {
      path: "/report/compile/index/:id",
      name: "compile-index",
      component: () => import("@/components/CompileIndexIndex"),
    },
    {
      path: "/report/compile/index/item/:id/:index",
      name: "compile-index-item",
      component: () => import("@/components/CompileIndexIndexItem"),
    },
    {
      path: "/yacht-list",
      name: "yacht-list",
      component: () => import("@/components/YachtList"),
    },
    {
      path: "/yatch-details/:id",
      name: "yatch-details",
      component: () => import("@/components/YachtDetails"),
    },
    {
      path: "/worklist/report/:id",
      name: "worklists",
      component: () => import("@/components/Worklists"),
    },
    {
      path: "/worklist/report/details/:id",
      name: "worklist-details",
      component: () => import("@/components/WorklistDetails"),
    },
    {
      path: "/worklist/report/edit/:id",
      name: "worklist-edit",
      component: () => import("@/components/WorklistEdit"),
    },
    {
      path: "/report/compile/worklist/:id",
      name: "compile-worklist",
      component: () => import("@/components/CompileWorklist"),
    },
    {
      path: "/worklist/compile/index/:id/:index",
      name: "compile-worklist-index",
      component: () => import("@/components/CompileWorklistIndex"),
    },

  ]
})

new Vue({
  router,
  beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  store,
  render: h => h(App),
}).$mount('#app')
